import React from 'react';
export const DesignPolicy = () => {
  return <div className="py-20 lg:py-24 bg-white min-h-[calc(100vh-300px)]" data-id="element-525">
      <div className="max-w-content mx-auto px-5 sm:px-8 lg:px-12" data-id="element-526">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-527">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-ink mb-6 leading-tight" data-id="element-528">
            Design Policy
          </h1>
          <p className="text-lg text-gray-600" data-id="element-529">
            Guidelines and requirements for custom artwork and designs.
          </p>
        </div>

        <div className="max-w-3xl mx-auto prose prose-lg prose-red text-gray-600" data-id="element-530">
          <h3 data-id="element-531">Artwork Requirements</h3>
          <p data-id="element-532">
            To ensure the highest quality print, all custom logos and artwork
            must be submitted in vector format (.AI, .EPS, .SVG, or vector
            .PDF). Raster images (.JPG, .PNG) must be high resolution (minimum
            300 DPI at actual print size), though vector is strongly preferred
            for crisp edges.
          </p>

          <h3 data-id="element-533">Copyright and Trademarks</h3>
          <p data-id="element-534">
            By submitting a design or logo, you warrant that you have the legal
            right to use the intellectual property. Custom Uniform Supplier
            reserves the right to refuse any order that we believe may infringe
            upon the trademarks, copyrights, or other intellectual property
            rights of third parties.
          </p>

          <h3 data-id="element-535">Design Approvals</h3>
          <p data-id="element-536">
            Before production begins, you will receive a digital mockup for
            final approval. It is your responsibility to carefully review this
            mockup for accuracy, including colors, spelling, logo placement, and
            sizing. Once the mockup is approved, the order moves to production
            and cannot be changed.
          </p>

          <h3 data-id="element-537">Color Matching</h3>
          <p data-id="element-538">
            While we strive for accurate color reproduction, slight variations
            may occur between digital mockups (which are viewed on backlit
            screens) and the final printed fabric. If precise color matching is
            critical, we recommend ordering a physical product sample.
          </p>
        </div>
      </div>
    </div>;
};